export default {
    fullname: '苍溪县精神卫生中心(苍溪县第二人民医院）',
    hospital: '苍溪县精神卫生中心',
    app_name: '苍溪县精神卫生中心(苍溪县第二人民医院）微信公众号',
    title: '(苍溪县第二人民医院）',
    max_card: 5,
}